
import { Component, OnInit ,ChangeDetectorRef,ChangeDetectionStrategy,OnDestroy} from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from "../../services/users.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-module-failed',
  templateUrl: './module-failed.component.html',
  styleUrls: ['./module-failed.component.scss']
})
export class ModuleFailedComponent implements OnInit {
  ModulSubData:any=[];moduleName:any='';
  userLoginData:any=[];EvaluationResultFail:any=[];assId:any='';assessmentType:any;courseId:any='';moduleId:any='';submoduleId:any='';isPassed:any; type:string=''
  request_status:number=1;user_id:any;

  constructor(private router: Router,private authUser: UsersService,private route: ActivatedRoute,private spinner: NgxSpinnerService,
    private modalService: NgbModal) {
    if (localStorage.getItem('userLoginData') =='' || localStorage.getItem('userLoginData') == null) {
      this.router.navigateByUrl('/');
    }
   }
  //  open(content: any) {
  //   this.modalService.open(content, { centered: true, size: 'sm' });
  // }
  open(content: any) { 
    this.user_id = this.userLoginData.user_id
    if(this.type=='ass'){
      this.contactAdministratorForAss(this.user_id,this.assId, this.request_status)
    }
    else{
      this.contactAdministrator(this.user_id,this.courseId,this.assId, this.request_status)
    }

    this.modalService.open(content, { centered: true, size: 'sm' }); 
  }
  open1(content: any) { 
    this.modalService.open(content, { centered: true, size: 'sm', backdrop: 'static', keyboard: false  }); 
  }
  ngOnInit(): void {
   
    this.moduleName = JSON.parse(localStorage.getItem('moduleName') || '[]');
    this.EvaluationResultFail = JSON.parse(localStorage.getItem('EvaluationResultFail') || '[]');
    this.userLoginData = JSON.parse(localStorage.getItem('userLoginData') || '[]');
    this.route.queryParams.subscribe(queryParams => {
      this.assId = queryParams['assId']; 
      this.courseId = queryParams['courseId']; this.moduleId = queryParams['modId'];
      this.assessmentType = queryParams['AT'];
      this.submoduleId = queryParams['subModlId'];
      this.isPassed = queryParams['isPassed'];
      this.type = queryParams['type']
    });
    if(this.submoduleId != undefined ){
      this.ModulSubData = JSON.parse(localStorage.getItem('ModulSubData') || '[]');
    }
  }
  contactAdministrator(user_id:number,course_id:any,assessment_id:any, request_status:any){
    this.spinner.show();
    this.authUser.contactAdministrator(user_id,course_id,assessment_id, request_status).subscribe(
      data=>{
        if(data.status == 401){
          document.getElementById('successMsg')?.click();
          this.spinner.hide();
        }else{
          this.spinner.hide();
        }
       
      },error=>{
        this.spinner.hide();
      }
    )
  }
  contactAdministratorForAss(user_id:number,assessment_id:any, request_status:any){
    this.spinner.show();
    this.authUser.contactAdministratorForAss(user_id,assessment_id, request_status).subscribe(
      data=>{
        if(data.status == 401){
            document.getElementById('successMsg')?.click();
            this.spinner.hide();
        }else{
        this.spinner.hide();
        }
      
      },error=>{
        this.spinner.hide();
      }
    )
  }
  backToDetailPage(parm:any){
    if(parm=='ass'){
      this.router.navigate(['/assessments'])
    }
    else{
      this.router.navigate(['/assigned_details_resume'], { queryParams: {courseId:this.courseId} });
    }
  }
  navigationEvent() {
    //localStorage.removeItem('userLoginData');
    //this.router.navigateByUrl('/assigned'); 
    
    }
}
